import {faList} from '@fortawesome/pro-regular-svg-icons';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {ActionIcon, Tooltip} from '@mantine/core';
import {Link} from 'react-router-dom';
import {ReviewsService} from '../../api/generated/ReviewsService';
import {BasicPage} from '../../components/basic-page';
import {
  PagedDataTableConfig,
  usePagedDataTable,
} from '../../hooks/paged-data-table/use-paged-data-table';
import {ROUTES} from '../../routes';
import {renderedDateFormat} from '../../utils/luxon.ts';
import {getColorForStatus} from '../job-highlight.tsx';
import {ReviewStatuses} from '../../api/generated/enums.ts';

export const ReviewInbox = () => {
  const pagedDataTable = usePagedDataTable(
    ReviewsService.getAllInbox,
    TableConfig,
  );

  return <BasicPage title='Review Inbox'>{pagedDataTable}</BasicPage>;
};

const getHighlightColor = (value: string | undefined) => {
  if (value === ReviewStatuses['Pending Review'])
    return getColorForStatus(
      'reviewInboxStatus',
      ReviewStatuses['Pending Review'],
    );
  if (value === ReviewStatuses['Review Completed'])
    return getColorForStatus(
      'reviewInboxStatus',
      ReviewStatuses['Review Completed'],
    );
  return getColorForStatus(
    'reviewInboxStatus',
    ReviewStatuses['Request More Information'],
  );
};

const TableConfig = PagedDataTableConfig(ReviewsService.getAllInbox, {
  columns: [
    {
      title: '',
      accessor: '',
      render: (item) => (
        <Tooltip label={"View this Job's Review Log"}>
          <ActionIcon
            component={Link}
            className='clear'
            aria-label={"View this Job's Review Log"}
            to={ROUTES.ADMIN.JOB_REVIEWS.INDEX.buildPath({
              jobId: Number(item.jobId),
            })}
          >
            <FontAwesomeIcon icon={faList} />
          </ActionIcon>
        </Tooltip>
      ),
      width: 50,
    },
    {
      title: 'Job ID',
      accessor: 'jobId',
    },
    {
      title: 'Partner Site',
      accessor: 'partnerSite',
    },
    {
      title: 'Part Number',
      accessor: 'jobPartNumber',
    },
    {
      title: 'Serial Number',
      accessor: 'jobSerialNumber',
    },
    {
      title: 'Level of Service',
      accessor: 'levelOfService',
    },
    {
      title: 'Job Status',
      accessor: 'jobStatus',
    },
    {
      title: 'Review Status',
      accessor: 'status',
      cellsStyle: (item) => ({
        backgroundColor: getHighlightColor(item.status),
      }),
    },
    {
      title: 'Date',
      accessor: 'createdDate',
      render: (item) => renderedDateFormat(item.createdDate),
    },
  ],
  searchFieldNames: ['jobStatus', 'status', 'jobId'],
});
